import { handleErrorAxios } from "@/common/lib/formatter";
import Http from "@/common/lib/http";

const commitFlow = (commit, onboardingFlow) => {
    if (!onboardingFlow) return;
    commit("SET_ONBOARDING_FLOW", onboardingFlow);
    commit("SET_COMPLETED_STEPS", onboardingFlow.completedSteps || []);
};

const actions = {
    async getOnboardingStatus({ commit }) {
        try {
            const { data } = await Http.instance.get(`/bo/onboarding/status`);
            commitFlow(commit, data.onboardingFlow);
            if (data.selections) {
                commit("SET_SELECTIONS", data.selections);
                if (data.selections.name) {
                    commit("auth/SET_TENANT_NAME", data.selections.name, {
                        root: true
                    });
                }
            }
            return data;
        } catch (errorAxios) {
            throw handleErrorAxios(errorAxios);
        }
    },
    async getSlugSuggestion(_context, { base, name, number, prefix }) {
        try {
            const { data } = await Http.instance.get(
                "/bo/onboarding/slug-suggestion",
                { params: { name, base, prefix, number } }
            );
            return data;
        } catch (errorAxios) {
            throw handleErrorAxios(errorAxios);
        }
    },
    async submitSlug({ commit }, { name, slug }) {
        try {
            const { data } = await Http.instance.post("/bo/onboarding/slug", {
                name,
                slug
            });
            // El backend puede aceptar la petición (200) pero no guardar
            // nada: si alguien más tomó el slug justo antes del submit,
            // devuelve slugSuggestion con uno nuevo en vez de fallar.
            if (data.slugSuggestion) {
                return data;
            }
            commitFlow(commit, data.onboardingFlow);
            commit("auth/SET_TENANT_NAME", name, { root: true });
            commit("auth/SET_TENANT_SLUG", slug, { root: true });
            return data;
        } catch (errorAxios) {
            throw handleErrorAxios(errorAxios);
        }
    },
    async submitBusinessType({ commit }, { businessType }) {
        try {
            const { data } = await Http.instance.post(
                "/bo/onboarding/business-type",
                { businessType }
            );
            commitFlow(commit, data.onboardingFlow);
            commit("SET_BUSINESS_TYPE", businessType);
            return data;
        } catch (errorAxios) {
            throw handleErrorAxios(errorAxios);
        }
    },
    async submitBranding({ commit }, payload) {
        try {
            const { data } = await Http.instance.post(
                "/bo/onboarding/branding",
                payload
            );
            commitFlow(commit, data.onboardingFlow);
            return data;
        } catch (errorAxios) {
            throw handleErrorAxios(errorAxios);
        }
    },
    async submitSocialNetworks({ commit }, payload) {
        try {
            const { data } = await Http.instance.post(
                "/bo/onboarding/social-networks",
                payload
            );
            commitFlow(commit, data.onboardingFlow);
            return data;
        } catch (errorAxios) {
            throw handleErrorAxios(errorAxios);
        }
    },
    async confirmProducts({ commit }) {
        try {
            const { data } = await Http.instance.post(
                "/bo/onboarding/products"
            );
            commitFlow(commit, data.onboardingFlow);
            return data;
        } catch (errorAxios) {
            throw handleErrorAxios(errorAxios);
        }
    },
    async getOnboardingPlans() {
        try {
            const { data } = await Http.instance.get("/bo/onboarding/plans");
            return data;
        } catch (errorAxios) {
            throw handleErrorAxios(errorAxios);
        }
    },
    // Free/prueba: { onboardingFlow, permissions }. Pagar ahora:
    // { onboardingFlow, invoiceId, paymentUrl } (el flow no avanza hasta
    // que se confirme el pago).
    async submitPlan({ commit }, { mode, planSlug }) {
        try {
            const { data } = await Http.instance.post("/bo/onboarding/plan", {
                planSlug,
                mode
            });
            if (!data.paymentUrl) {
                commitFlow(commit, data.onboardingFlow);
            }
            return data;
        } catch (errorAxios) {
            throw handleErrorAxios(errorAxios);
        }
    },
    async confirmCustomLinks({ commit }) {
        try {
            const { data } = await Http.instance.post(
                "/bo/onboarding/custom-links"
            );
            commitFlow(commit, data.onboardingFlow);
            return data;
        } catch (errorAxios) {
            throw handleErrorAxios(errorAxios);
        }
    },
    setStepperUi({ commit }, payload) {
        commit("SET_STEPPER_UI", payload);
    },
    hydrateOnboardingDraft({ commit, state }) {
        commit("HYDRATE_DRAFT", state.selections);
    },
    // Señal (contador) para que el layout le pida a la página activa que
    // ejecute su propio stepperNext(); no es un dato de dominio, solo un
    // trigger observado por el mixin onboardingStepNavigation.
    requestNext({ commit }) {
        commit("BUMP_NEXT_TOKEN");
    }
};

export default actions;
